import * as React from "react";

import { useState, useEffect, useMemo } from "react";

import Grid from "@mui/material/Grid";

import { sortData } from "../../../Logic/sortData";
import TableDisplay from "./TableDisplay";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import { useSelector } from "react-redux/es/exports";

import { getCounts } from "../../../State/Actions/Data/getCounts";
import { getCountsMatchingSearch } from "../../../State/Actions/Data/getCountsMatchingSearch";
import { getCountsMatchingCheckboxFilters } from "../../../State/Actions/Data/getCountsMatchingCheckboxFilters";
import { getCountsMatchingBoth } from "../../../State/Actions/Data/getCountsMatchingBoth";

export default function TableOfCategories({
  categoricalColumn,
  categoricalColumnDisplay,
  categoriesAndCounts,
}) {
  const unfilteredData = useSelector((state) => state.unfilteredData);
  const filteredIdsBasedOnSearchBox = useSelector(
    (state) => state.filteredIdsBasedOnSearchBox
  );

  const filteredIdsBasedOnPrecisionSearch = useSelector(
    (state) => state.filteredIdsBasedOnPrecisionSearch
  );

  const filteredIdsBasedOnCheckboxes = useSelector(
    (state) => state.filteredIdsBasedOnCheckboxes
  );

  const advancedSearchOn = useSelector((state) => state.advancedSearchOn);

  // const [sortColumn, setSortColumn] = useState("variables");
  // const [sortDescending, setSortDescending] = useState(true);

  const [sortColumn, setSortColumn] = useState(null);
  const [sortDescending, setSortDescending] = useState(false);

  const [searchString, setSearchString] = useState("");

  const originalTableData = useMemo(() => {
    const results = getCounts(
      unfilteredData,
      categoricalColumn,
      categoriesAndCounts
    );

    const resultsMatchingSearch = getCountsMatchingSearch(
      unfilteredData,
      categoricalColumn,
      filteredIdsBasedOnSearchBox,
      filteredIdsBasedOnPrecisionSearch,
      advancedSearchOn,
      categoriesAndCounts
    );

    const resultsMatchingCheckboxes = getCountsMatchingCheckboxFilters(
      unfilteredData,
      categoricalColumn,
      filteredIdsBasedOnCheckboxes,
      categoriesAndCounts
    );

    const resultsMatchingBoth = getCountsMatchingBoth(
      unfilteredData,
      categoricalColumn,
      filteredIdsBasedOnSearchBox,
      filteredIdsBasedOnPrecisionSearch,
      filteredIdsBasedOnCheckboxes,
      advancedSearchOn,
      categoriesAndCounts
    );

    const originalTableData = [];
    for (const datum of categoriesAndCounts) {
      const tableDatum = {};
      tableDatum[categoricalColumn] = datum["category"];
      tableDatum["variables"] = results[datum["category"]];
      tableDatum["matchingSearch"] = resultsMatchingSearch[datum["category"]];
      tableDatum["matchingCheckboxes"] =
        resultsMatchingCheckboxes[datum["category"]];
      tableDatum["matchingBoth"] = resultsMatchingBoth[datum["category"]];

      originalTableData.push(tableDatum);
    }

    return originalTableData;
  }, [
    categoriesAndCounts,
    categoricalColumn,
    filteredIdsBasedOnSearchBox,
    filteredIdsBasedOnPrecisionSearch,
    advancedSearchOn,
  ]);

  useEffect(() => {
    const results = getCounts(
      unfilteredData,
      categoricalColumn,
      categoriesAndCounts
    );

    const resultsMatchingSearch = getCountsMatchingSearch(
      unfilteredData,
      categoricalColumn,
      filteredIdsBasedOnSearchBox,
      filteredIdsBasedOnPrecisionSearch,
      advancedSearchOn,
      categoriesAndCounts
    );

    const resultsMatchingCheckboxes = getCountsMatchingCheckboxFilters(
      unfilteredData,
      categoricalColumn,
      filteredIdsBasedOnCheckboxes,
      categoriesAndCounts
    );

    const resultsMatchingBoth = getCountsMatchingBoth(
      unfilteredData,
      categoricalColumn,
      filteredIdsBasedOnSearchBox,
      filteredIdsBasedOnPrecisionSearch,
      filteredIdsBasedOnCheckboxes,
      advancedSearchOn,
      categoriesAndCounts
    );

    const originalTableData = [];
    for (const datum of categoriesAndCounts) {
      const tableDatum = {};
      tableDatum[categoricalColumn] = datum["category"];
      tableDatum["variables"] = results[datum["category"]];
      tableDatum["matchingSearch"] = resultsMatchingSearch[datum["category"]];
      tableDatum["matchingCheckboxes"] =
        resultsMatchingCheckboxes[datum["category"]];
      tableDatum["matchingBoth"] = resultsMatchingBoth[datum["category"]];

      originalTableData.push(tableDatum);
    }
    setSortedData(sortData(sortColumn, sortDescending, originalTableData));
  }, [filteredIdsBasedOnCheckboxes]);

  const [sortedData, setSortedData] = useState(originalTableData);

  useEffect(() => {
    const results = getCounts(
      unfilteredData,
      categoricalColumn,
      categoriesAndCounts
    );
    const resultsMatchingSearch = getCountsMatchingSearch(
      unfilteredData,
      categoricalColumn,
      filteredIdsBasedOnSearchBox,
      filteredIdsBasedOnPrecisionSearch,
      advancedSearchOn,
      categoriesAndCounts
    );

    const resultsMatchingCheckboxes = getCountsMatchingCheckboxFilters(
      unfilteredData,
      categoricalColumn,
      filteredIdsBasedOnCheckboxes,
      categoriesAndCounts
    );

    const resultsMatchingBoth = getCountsMatchingBoth(
      unfilteredData,
      categoricalColumn,
      filteredIdsBasedOnSearchBox,
      filteredIdsBasedOnPrecisionSearch,
      filteredIdsBasedOnCheckboxes,
      advancedSearchOn,
      categoriesAndCounts
    );

    const originalTableData = [];
    for (const datum of categoriesAndCounts) {
      const tableDatum = {};
      tableDatum[categoricalColumn] = datum["category"];
      tableDatum["variables"] = results[datum["category"]];
      tableDatum["matchingSearch"] = resultsMatchingSearch[datum["category"]];
      tableDatum["matchingCheckboxes"] =
        resultsMatchingCheckboxes[datum["category"]];
      tableDatum["matchingBoth"] = resultsMatchingBoth[datum["category"]];

      originalTableData.push(tableDatum);
    }

    setSortedData(sortData(sortColumn, sortDescending, originalTableData));
  }, [sortColumn, sortDescending, originalTableData]);

  // handle textField change
  const handleChange = (e) => {
    setSearchString(e.target.value);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          component="form"
          sx={{
            "& > :not(style)": { m: 1, width: "25ch" },
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-basic"
            label="Filter Terms Below..."
            variant="outlined"
            value={searchString}
            onChange={handleChange}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <TableDisplay
          categoricalColumn={categoricalColumn}
          categoricalColumnDisplay={categoricalColumnDisplay}
          sortedData={sortedData}
          sortColumn={sortColumn}
          sortDescending={sortDescending}
          setSortColumn={setSortColumn}
          setSortDescending={setSortDescending}
          searchString={searchString}
        ></TableDisplay>
      </Grid>
    </Grid>
  );
}
